import StaffComplianceContainer from "./StaffCompliance.container";

export default StaffComplianceContainer;
